import { apiCall } from '@/util/apiCall'
import type { Line } from '@common/types/Line'
import { insertLines } from '../lines'
import { makeLoader } from './load'

export const loadLines = makeLoader({
	id: 'lines',
	loader: async api => {
		const { data: lines } = await apiCall<{ data: Line[] }>('/lines', {
			signal: api.signal,
			cache: 'preload-if-ssr',
		})
		return insertLines(lines)
	},
})
